export const MFA_METHODS = {
  SOFTWARE_TOKEN_MFA: "SOFTWARE_TOKEN_MFA",
  EMAIL_MFA: "EMAIL_MFA",
  SMS_MFA: "SMS_MFA",
};

export const MFA_LABELS = {
  SOFTWARE_TOKEN_MFA: "Authenticator app",
  EMAIL_MFA: "Email",
  SMS_MFA: "SMS",
};

export const LOCATION_TYPES = [
  { key: "Headquarters", value: "Headquarters" },
  { key: "Corporate_Office", value: "Corporate Office" },
  { key: "store", value: "Store" },
];

// ROOT-level keys of `location.settings`. Index into
// `useLocationHelpers().locationSettings` with one of these to read that whole
// branch of the settings blob.
export const LOCATION_SETTING_KEYS = {
  GENERAL_CONFIG: "GENERAL_CONFIG",
  REPORT_SETTINGS: "REPORT_SETTINGS",
};

// Keys inside `location.settings.GENERAL_CONFIG` that the General settings
// section owns. Kept here so the admin writer and the user-side readers agree
// on the exact key — a typo on either end silently reads as `false`.
export const GENERAL_CONFIG_KEYS = {
  // When true, a user who is restricted from removing the "My conversations"
  // filter (ACTIVITY_CENTER_RESTRICT_REMOVE_DEFAULT_FILTER) may still pick the
  // "All Leads" search scope in the activity center / browser extension.
  ALLOW_ALL_LEADS_SEARCH_SCOPE: "ALLOW_ALL_LEADS_SEARCH_SCOPE",
};

export const LOCATION_S3_FOLDER = "/images/company-location-logos";
export const MAX_LOCATION_LOGO_SIZE_MB = 2;
